import Vue from "vue";
import SButton from "./SButton.vue";

Vue.component("SButton", SButton);
